const PoInvoiceCard = ({data}) => {
	return (
		<>

			<div className="col-xl-3 col-xxl-6 col-sm-6">
				<div className="card bg-warning invoice-card">
					<div className="card-body d-flex">
						<div className="icon me-3">
							<i className="bi bi-hdd-rack fs-4 text-white"></i>
						</div>
						<div>

							<h2 className="text-white invoice-num">{data?.totalPendingPO}  (Requisitions Request)</h2>
							<span className="text-white fs-18">Pending PO</span>
							
						</div>
					</div>
				</div>
			</div>
			<div className="col-xl-3 col-xxl-6 col-sm-6">
				<div className="card bg-success invoice-card">
					<div className="card-body d-flex">
						<div className="icon me-3">
							<i className="bi bi-cart-plus fs-4 text-white"></i>
						</div>
						<div>
							<h2 className="text-white invoice-num">{data?.generatedPO}</h2>
							<span className="text-white fs-18">PO Generated</span>
						</div>
					</div>
				</div>
			</div>
			<div className="col-xl-3 col-xxl-6 col-sm-6">
				<div className="card bg-info invoice-card">
					<div className="card-body d-flex">
						<div className="icon me-3">
							<i className="bi bi-truck fs-4 text-white"></i>
						</div>
						<div>
							<h2 className="text-white invoice-num">{data?.orderReceived}</h2>
							<span className="text-white fs-18">Order Received Completed</span>
						</div>
					</div>
				</div>
			</div>
			<div className="col-xl-3 col-xxl-6 col-sm-6">
				<div className="card bg-secondary invoice-card">
					<div className="card-body d-flex">
						<div className="icon me-3">
							<i className="bi bi-bag-plus fs-4 text-white"></i>
						</div>
						<div>
							<h2 className="text-white invoice-num">{data?.partiallOrderReceived}</h2>
							<span className="text-white fs-18">Patiall Order Received</span>
						</div>
					</div>
				</div>
			</div>
			<div className="col-xl-6 col-xxl-12 col-sm-12">
				<div className="card bg-secondary invoice-card">
					<div className="card-body d-flex justify-content-center align-items-center text-center" style={{ height: '100%' }}>
						<div className="d-flex justify-content-center align-items-center">
							<div className="icon me-3">
								<i className="bi bi-cart-dash fs-4 text-white"></i>
							</div>
							<div>
								<h2 className="text-white invoice-num">{data?.data?.totalSubmittedMiv}</h2>
								<span className="text-white fs-18">Pending Material Issue Voucher</span>
							</div>
						</div>
					</div>
				</div>
			</div>

		</>
	)
}
export default PoInvoiceCard;